/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSyncEntitiesClientRequest} from '@cash-web/protos/squareup/cash/clientsync/app.pb'
import {GetSyncEntitiesClientResponse} from '@cash-web/protos/squareup/cash/clientsync/app.pb'


export const getSyncEntities = (request:GetSyncEntitiesClientRequest, options?: CashRequestOptions) => post<GetSyncEntitiesClientRequest, GetSyncEntitiesClientResponse>("/2.0/cash/get-sync-entities", request, {...options, rejectOnError: true })